<script setup lang="ts">
import SelectDemoEla from './SelectDemoEla.vue'
import SelectDemoMath from './SelectDemoMath.vue'
import SelectPaidEla from './SelectPaidEla.vue'
import SelectPaidMath from './SelectPaidMath.vue'

defineOptions({
  name: 'PaymentPolicySelectors',
})
</script>

<template>
  <div class="payment-policy-selectors">
    <SelectDemoMath />
    <SelectDemoEla />
    <SelectPaidMath />
    <SelectPaidEla />
  </div>
</template>

<style scoped lang="scss" src="./PaymentPolicySelectors.scss" />
